module.exports = __webpack_public_path__ + "img/CheckCircleOutlined.49be51f7.svg";